#import "./AddressFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"

fragment CustomerFull on Customer {
  id
  fullName
  email
  phoneNumber
  billingAddress {
    ...AddressFull
  }
  contactAddress {
    ...AddressFull
  }
  gdprApprovedAt
  company {
    cin
    name
    vat
  }
  ...TimestampsFull
  ...SearchIndexFull
}
